import { Language } from 'model';
import { useAppSelector } from '../../../redux/redux.hooks';
import { selectAllLanguages } from '../redux/languages.slice';

export function useSelectLanguages(ids: string[]): Language[] {
  return useAppSelector((state) =>
    selectAllLanguages(state).filter((l) => ids.includes(l.id))
  );
}
